import { and, eq, gte, lte } from "drizzle-orm";
import { order, order_line, payment, type PowerSyncDrizzleDB } from "@comandero/powersync";
import { liveOrderFilters, liveOrderLineFilters, livePaymentFilters } from "../live/filters";

/**
 * Branch orders in a range [fromISO, toISO] by `closed_at`. The range
 * is optional; without it brings all orders (not deleted) of the branch. The
 * aggregations (totals, hourly, by employee) live in `sales-report.ts`.
 */
export function getReportOrdersQuery(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  branchId: string,
  range?: { fromISO?: string; toISO?: string },
) {
  const filters = [
    eq(order.organization_id, organizationId),
    eq(order.branch_id, branchId),
    ...liveOrderFilters(),
  ];
  if (range?.fromISO) {
    filters.push(gte(order.closed_at, range.fromISO));
  }
  if (range?.toISO) {
    filters.push(lte(order.closed_at, range.toISO));
  }
  return db
    .select()
    .from(order)
    .where(and(...filters));
}

/**
 * All org order lines (for sales by product). The cohort
 * `liveOrderLineFilters` excludes lines whose ORDER is voided (soft-delete),
 * which the loose per-line filter did not see — fixes double counting of voided orders.
 */
export function getReportLinesQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(order_line)
    .where(and(eq(order_line.organization_id, organizationId), ...liveOrderLineFilters()));
}

/**
 * All org payments (for tips and employee attribution). The cohort
 * `livePaymentFilters` excludes payments from voided orders (phantom tips).
 */
export function getReportPaymentsQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(payment)
    .where(and(eq(payment.organization_id, organizationId), ...livePaymentFilters()));
}
